﻿import React, { useState } from 'react';
import { Button, Popconfirm, Table } from 'antd';
import { ExternalLayerTypes } from './LayerTypes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faTimes } from '@fortawesome/pro-regular-svg-icons';
import { ExternalChartLayer } from './LayerInterfaces';


interface Props {
    layers: ExternalChartLayer[],
    onEdit: (layer: ExternalChartLayer) => void,
    onRemove: (id: number) => void,
    pagination: boolean
}

const LayerTable: React.FC<Props> = (props) => {

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            width: '200px',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            width: '70px',
            render: (_: any, record: ExternalChartLayer) => {
                if (record.type == ExternalLayerTypes.WMS)
                    return "WMS";
                else
                    return "WMTS";
            }
        },
        {
            title: 'Capabilities Url',
            dataIndex: 'capabilitiesUrl',
        },
        {
            title: 'Layers',
            dataIndex: 'layers',
            width: '300px',
            render: (_: any, record: ExternalChartLayer) => {
                return record.layers;
            },
        },
        {
            title: '',
            dataIndex: 'operation',
            width: '80px',
            fixed: 'right' as any,
            render: (_: any, record: ExternalChartLayer) => {
                return (
                    <>
                        <Button onClick={() => props.onEdit(record)} icon={<FontAwesomeIcon icon={faPencil} />} style={{ marginRight: 8 }} />
                        <Popconfirm title="Sure to remove?" onConfirm={() => props.onRemove(record.id)}>
                            <Button icon={<FontAwesomeIcon icon={faTimes} />} danger />
                        </Popconfirm>
                    </>
                );
            },
        },
    ];

    return (
        <Table columns={columns} dataSource={props.layers.filter(l => l.id != -1 && l.isWritable)} rowKey={"id"} pagination={props.pagination ? undefined : false} scroll={{ x: 800 }}/>
    );
}

export default LayerTable;